import { render, staticRenderFns } from "./RequestsList.vue?vue&type=template&id=1b2fa3b1&scoped=true&"
import script from "./RequestsList.vue?vue&type=script&lang=js&"
export * from "./RequestsList.vue?vue&type=script&lang=js&"
import style0 from "./RequestsList.vue?vue&type=style&index=0&id=1b2fa3b1&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2fa3b1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
